import type { CmsLink } from '@omnia/ui/src/lib'
import { useLogger } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { CardGridVenuePropsApi } from '../models'
import { GenericCard } from './GenericCard'

export const VenueCard: FC<CardGridVenuePropsApi> = props => {
    const logger = useLogger(['CardGrid', 'VenueCard'])

    logger.trace('Rendering', { props })

    const {
        venueCardImage,
        addressLine1,
        addressLine2,
        addressLine3,
        city,
        postcode,
        nearestStationName,
        nearestStationType,
    } = props?.venue?.cinemaLocationDetailsElement ?? {}

    const addressString = [addressLine1, addressLine2, addressLine3, city, postcode].filter(Boolean).join(', ')

    const link: CmsLink = props?.link || {
        url: props?.venue?.url,
        target: '_self',
        name: props?.venue?.name,
    }

    return (
        <GenericCard
            image={venueCardImage}
            link={link}
            title={props?.venue?.name}
            description={addressString}
            nearestStationName={nearestStationName}
            nearestStationType={nearestStationType}
        />
    )
}
